// extracted by mini-css-extract-plugin
export var locationCard = "_oe-0";